<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="actionUrl" method="POST" role="form">

      <p>
        <span class="text-danger" v-if="error">{{ error }}</span>
      </p>

      <template v-if="deletion">
        <p>Are you sure you want to delete <em>'{{ data.label }}'</em>?</p>
      </template>
      <template v-else>

        <div class="form-group row">
          <label for="input-label" class="col-sm-3 col-form-label">Label:</label>
          <div class="col-sm-9">
            <input type="text" name="label" id="input-label" class="form-control form-control-sm" required="required"
                   v-model="data.label" placeholder="Contact type display name">
            <small class="text-danger" v-if="errors.label">{{ errors.label[0] }}</small>
          </div>
        </div>

        <div class="form-group row">
          <label for="input-description" class="col-sm-3 col-form-label">Description:</label>
          <div class="col-sm-9">
            <input type="text" name="description" id="input-description" class="form-control form-control-sm"
                   v-model="data.description" placeholder="Contact type description">
            <small class="text-danger" v-if="errors.description">{{ errors.description[0] }}</small>
          </div>
        </div>

        <div class="form-group row">
          <label for="groups" class="col-sm-3 col-form-label">Claim Group:</label>
          <div class="col-sm-9">
            <chosen :id="'chosen' + id"
                    name="groups"
                    label="name"
                    :options="claimTypeGroups"
                    placeholder="Select claim groups..."
                    :multiple="true"
                    class="form-control form-control-sm" v-model="data.groups"></chosen>
            <template v-if="errors.groups">
              <small class="text-danger">{{ errors.groups[0] }}</small>
              <br>
            </template>
            <small>Contact type will be available only for claims with appropriate Claim Type; or in claims with unset
              Claim Type if this field is left blank.</small>
          </div>
        </div>

        <div class="form-group row">
          <div class="offset-sm-3 col-sm-9">
            <label class="mr-2">
              <input type="checkbox" name="shared" id="input-shared" class=""
                     v-model="data.shared" :disabled="shareDisabled">
              Shared contact
            </label>
            <br>
            <template v-if="errors.shared">
              <small class="text-danger">{{ errors.shared[0] }}</small>
              <br>
            </template>
            <small v-if="shareDisabled">At the moment, turning off this option is not available.</small>
          </div>
        </div>

        <div class="form-group row">
          <div class="offset-sm-3 col-sm-9">
            <label class="mr-2">
              <input type="checkbox" name="require_w9" v-model="data.require_w9">
              Require "W9 on file" option
            </label>
            <br>
            <template v-if="errors.require_w9">
              <small class="text-danger">{{ errors.require_w9[0] }}</small>
              <br>
            </template>
          </div>
        </div>

      </template>

      <input type="hidden" name="_method" :value="method">
    </form>

    <template #footer>
      <template v-if="deletion">
        <button type="button" class="btn btn-default" @click="cancelDeletion"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="button" class="btn btn-danger" @click="deleteSubmit"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>
      <template v-else>
        <button type="button" class="btn btn-danger mr-auto" v-if="isExisting && data.deletable" @click="prepareDeletion"><i class="fa fa-fw fa-trash"></i> Delete</button>
        <small  class="mr-auto" v-if="isExisting && !data.deletable">Note: This content type can't be deleted.</small>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="button" class="btn btn-primary" :disabled="isEmpty" @click="createUpdateSubmit"><i class="fa fa-fw fa-upload"></i> Save changes</button>
      </template>
    </template>

  </modal>

</template>

<style scoped>
</style>

<script>

import HasModal from "../mixins/HasModal";

export default {
  mixins: [HasModal],

  props: {

    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'lookup-contact_type-item-modal'
    },
    id: {
      type: Number,
      default: 0
    },
    action: {
      type: String,
      required: true
    },
    actionDelete: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: () => {
        return [];
      }
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    shared: {
      type: Boolean,
      default: false
    },
    requireW9: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    unsharable: {
      type: Boolean,
      default: false
    },
    claimTypeGroups: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
  },

  data() {
    return {
      data: {
        id: this.id,
        groups: this.groups,
        label: this.label,
        description: this.description,
        shared: this.shared,
        require_w9: this.requireW9,
        deletable: this.deletable,
        unsharable: this.unsharable,
      },
      error: '',
      errors: [],
      deletion: false,
      modalShown: false,
    }
  },
  computed: {
    formId() {
      return this.modalId + '-form';
    },
    title() {
      if (this.deletion) return "Delete Contact Type list item";
      return this.isNew ? "Add Contact Type list item" : "Edit Contact Type list item";
    },
    method() {
      if (this.deletion) return "DELETE";
      return this.isNew ? "POST" : "PATCH";
    },
    actionUrl() {
      return this.deletion ? this.actionDelete : this.action;
    },
    hasData() {
      return !!(this.data.label && this.data.label.trim().length);
    },
    isEmpty() {
      return !this.hasData;
    },
    isExisting() {
      return this.data.id > 0;
    },
    isNew() {
      return !this.isExisting;
    },
    shareDisabled() {
      return !!this.shared && this.data.unsharable;
    }
  },
  methods: {

    /**
     * Submit create/update.
     */
    createUpdateSubmit() {

      this.error = '';
      this.errors = Object.assign(this.errors, {});

      let formData = this.formData();
      formData.append('_method', this.method);
      formData.append('_token', this.$csrf_token);

      axios.post(this.actionUrl, formData)
          .then(response => {
            window.location.reload();
          })
          .catch(error => {
            this.handleErrors(error, 'Unable to submit form.')
          });
    },

    /**
     * Submit delete request.
     */
    deleteSubmit() {
      let formData = new FormData();
      formData.append('_method', this.method);
      formData.append('_token', this.$csrf_token);

      axios.post(this.actionUrl, formData)
          .then(response => {
            window.location.reload();
          })
          .catch(error => {
            this.handleErrors(error, 'Unable to delete contact type.')
          });
    },

    /**
     * Prepare form data.
     */
    formData() {
      const formData = new FormData();

      Object.keys(this.data).forEach(fieldName => {
        const value = this.data[fieldName] ? this.data[fieldName] : '';
        if (Array.isArray(this.data[fieldName])) {
          value.forEach(item => {
            formData.append(fieldName + '[]', item);
          })
        } else {
          formData.append(fieldName, value);
        }
      });

      return formData;
    },

    /**
     * Handle axios errors
     *
     * @param errorObj
     * @param defaultMessage
     */
    handleErrors(errorObj, defaultMessage) {
      if (errorObj.response.status === 422) {
        this.errors = errorObj.response.data.errors || {};
      } else {
        this.error = defaultMessage;
      }
    },

    prepareDeletion() {
      this.deletion = true;
    },

    cancelDeletion() {
      this.deletion = false;
    },
  }
}

</script>
